import * as React from "react";
import { useEffect, useState } from "react";

import Sidemenu from "./Sidemenu";
import toggleim from "../Assets/images/Vector.svg";
import notification from "../Assets/images/ic_round-notifications.svg";
import user from "../Assets/images/Frame 12.svg";
import { Alert, Modal, Button } from "react-bootstrap";
import Container from "react-bootstrap/Container";
import Nav from "react-bootstrap/Nav";
import Navbar from "react-bootstrap/Navbar";
import NavDropdown from "react-bootstrap/NavDropdown";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Tooltip from "react-bootstrap/Tooltip";
import axios from "axios";
import { baseURL } from "../config";
function Topbar({ Toggle }) {
  const [count, setCount] = useState(null);
  const [notificationText, setNotificationText] = useState(null);
  const [show, setShow1] = useState(false);

  const [notificationmsg, setNotificationMsg] = useState("");
  const [notificationId, setNotificationId] = useState(0);

  const handleClose1 = () => setShow1(false);

  const [showModal1, setShowModal1] = useState(false);
  const acknowledge1 = async () => {
    try {
      let reslt = await fetch(
        `${baseURL}/acknowledgeNotification?nid=` + notificationId
      );
      setNotificationId(null);
      setShow1(false);
    } catch (e) {}
  };

  useEffect(() => {
    const fetchAllEmployeeNotifications = async () => {
      try {
        let eid = localStorage.getItem("employeeid");
        let userid = localStorage.getItem("userid");
        let reslt = await fetch(
          `${baseURL}/getnotifications?eid=` + eid + "&id=" + userid
        );
        const res = await reslt.json();
        if (res.notifications.length > 0) {
          let msg = res.notifications[0].notification;
          let id = res.notifications[0].id;
          setNotificationMsg(msg);
          setNotificationId(id);

          if (msg) {
            setShow1(true);
          }
        }
      } catch (err) {
        console.error("Error fetching notifications:", err);
      }
    };
    fetchAllEmployeeNotifications();
    setShowModal1();
  }, []);

  const showNotification = () => {
    setShowModal1(true);
    setShow1(true);
  };

  const cnt = localStorage.getItem("notificationcnt");
  const renderTooltip = (props) => (
    <Tooltip id="notification-tooltip" {...props}>
      {notificationmsg}
    </Tooltip>
  );

  let profileimage = localStorage.getItem("profileimage");
  if (
    profileimage === "" ||
    profileimage === undefined ||
    profileimage === "null"
  ) {
    profileimage = "dummyphoto.png";
  }

  return (
    <>
      <Navbar expand="lg">
        <Container>
          <div className="col-lg-9">
            <a className="navbar-brand" onClick={Toggle}>
              <img src={toggleim} />
            </a>
            <Navbar.Brand href="#home"></Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
          </div>
          <div className="col-lg-2">
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="me-auto">
                <OverlayTrigger
                  placement="bottom"
                  delay={{ show: 250, hide: 400 }}
                  overlay={renderTooltip}
                >
                  <Nav.Link href="/notifications">
                    <img
                      className=""
                      src={notification}
                      alt="Notification Icon"
                    />
                  </Nav.Link>
                </OverlayTrigger>
                <NavDropdown
                  style={{ color: "white" }}
                  title="Profile Menu"
                  id="basic-nav-dropdown"
                >
                  <NavDropdown.Item
                    href="profile"
                    style={{ textDecoration: "none" }}
                  >
                    <a
                      href="/profile"
                      style={{
                        textDecoration: "none",
                        color: "black",
                        display: "flex",
                        alignItems: "center",
                      }}
                    >
                      <img
                        alt="gg"
                        src={
                          `${baseURL}/getcertifcate?filename=` +
                          profileimage
                        }
                        width="18"
                      />
                      &nbsp;&nbsp; My Profile
                    </a>
                  </NavDropdown.Item>
                  <NavDropdown.Item href="/">
                    <a
                      style={{
                        textDecoration: "none",
                        color: "black",
                        display: "flex",
                        alignItems: "center",
                      }}
                      href="/"
                    >
                      {" "}
                      <svg
                        stroke="currentColor"
                        fill="currentColor"
                        stroke-width="0"
                        viewBox="0 0 16 16"
                        height="18"
                        width="18"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          fill-rule="evenodd"
                          d="M10 12.5a.5.5 0 0 1-.5.5h-8a.5.5 0 0 1-.5-.5v-9a.5.5 0 0 1 .5-.5h8a.5.5 0 0 1 .5.5v2a.5.5 0 0 0 1 0v-2A1.5 1.5 0 0 0 9.5 2h-8A1.5 1.5 0 0 0 0 3.5v9A1.5 1.5 0 0 0 1.5 14h8a1.5 1.5 0 0 0 1.5-1.5v-2a.5.5 0 0 0-1 0v2z"
                        ></path>
                        <path
                          fill-rule="evenodd"
                          d="M15.854 8.354a.5.5 0 0 0 0-.708l-3-3a.5.5 0 0 0-.708.708L14.293 7.5H5.5a.5.5 0 0 0 0 1h8.793l-2.147 2.146a.5.5 0 0 0 .708.708l3-3z"
                        ></path>
                      </svg>{" "}
                      &nbsp;&nbsp;&nbsp;Logout
                    </a>
                  </NavDropdown.Item>
                </NavDropdown>
              </Nav>
            </Navbar.Collapse>
          </div>
        </Container>
      </Navbar>
      <div style={{ display: "none" }}>
        <Modal show={showModal1} onHide={handleClose1}>
          <Modal.Header closeButton>
            <Modal.Title>New message for you</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <Alert variant="danger">
              <p>{notificationmsg}</p>
            </Alert>
          </Modal.Body>
          <Modal.Footer>
            <a
              href="#"
              className="mt-4 btn btn-danger m-2"
              onClick={handleClose1}
            >
              {" "}
              Close
            </a>
            <a
              href="#"
              className="mt-4 btn btn-danger m-2"
              onClick={acknowledge1}
            >
              {" "}
              Acknowledge and Close
            </a>
          </Modal.Footer>
        </Modal>
      </div>
    </>
  );
}

export default Topbar;
